import React from 'react';
import {getComponentConfig, loadComponent, loadComponentById} from '../../utils/components';
import ContentLoader from "../layout/ContentLoader";
import PropTypes from "prop-types";
import {store} from "../../store";
import {showModal} from "../../actions";
import {trace} from "../../utils/request";
import Icon from "./Icon";
import {set} from "../../utils/dotutils";

export class ComponentLoader extends React.Component {

    static propTypes = {
        componentName: PropTypes.string,
        componentId: PropTypes.any,
        filter: PropTypes.any,
        aggregations: PropTypes.any,
        view: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
        componentAs: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
        dynamic: PropTypes.bool,
    }

    state = {
        isLoading: true,
        failed: false
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loadComponent();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(prevProps.componentName !== this.props.componentName || prevProps.componentId !== this.props.componentId || JSON.stringify(prevProps.filter) !== JSON.stringify(this.props.filter)) {
            this.loadComponent();
        }
    }

    loadComponent = () => {
        this.setState({isLoading: true, failed: false}, async () => {
            try {
                let component;
                if (this.props.componentId) {
                    component = await loadComponentById(this.props.componentName, this.props.componentId, this.props.view);
                } else {
                    component = await loadComponent(this.props.componentName, {filter: this.props.filter, group: this.props.aggregations}, this.props.view);
                }
                this.setState({isLoading: false, component});
            } catch (e) {
                console.error(e);
                this.setState({failed: e, isLoading: false});
                !this.props.onFailure && store.dispatch(showModal({
                    size: "large",
                    theme: "danger",
                    header: "Szerveroldali hiba",
                    body: trace({error: e})
                }));
            }
        });
    }

    render () {
        const thisProps = {...this.props};
        delete thisProps.children;
        let component = null;
        if (!this.state.isLoading && !this.state.failed) {
            const componentAs = (this.props.componentAs || "values");
            if (this.props.children instanceof Function) {
                let props = {
                    ...thisProps
                };
                if (this.props.dynamic || !(componentAs instanceof Function)) {
                    set(props, this.props.dynamic ? this.props.componentName : componentAs, this.state.component);
                } else if (componentAs instanceof Function) {
                    props = {
                        ...props,
                        ...componentAs(this.state.component, props)
                    };
                }
                component = this.props.children(props);
            } else {
                component = React.Children.map(this.props.children, (child) => {
                    if (child) {
                        let props = {
                            ...thisProps, ...child.props,
                        };
                        if (this.props.dynamic || !(componentAs instanceof Function)) {
                            set(props, this.props.dynamic ? this.props.componentName : componentAs, this.state.component);
                        } else if (componentAs instanceof Function) {
                            props = {
                                ...props,
                                ...componentAs(this.state.component, props)
                            };
                        }
                        return <child.type {...props}/>;
                    }
                    return child;
                });
            }
        } else if(this.state.failed) {
            if (this.props.onFailure) {
                component = this.props.onFailure instanceof Function ? this.props.onFailure(this.state.failed) : this.props.onFailure;
            }
        }
        if (this.state.isLoading) {
            return <ContentLoader>
                {component}
            </ContentLoader>;
        } else {
            return component || <Icon lib="fa" name="exclamation-triangle" />;
        }
    }
}

export default ComponentLoader;